import { Link } from "react-router-dom";
import { ShieldCheck, ScrollText, Mail, Facebook, Instagram, Sparkles } from "lucide-react";
import { BrandLogo } from "@/components/ui/brand-logo";

export const Footer = () => (
  <footer className="bg-brand-navy text-white">
    <div className="max-w-6xl mx-auto px-5 py-12">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div className="max-w-xs">
          <Link to="/"><BrandLogo dark /></Link>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">Privacy-first contact for everyone. Stay reachable, stay private.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-10">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Company</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors flex items-center gap-2" data-testid="footer-about"><Sparkles className="h-4 w-4" /> About Us</Link></li>
              <li><Link to="/privacy" className="text-slate-300 hover:text-white transition-colors flex items-center gap-2" data-testid="footer-privacy"><ShieldCheck className="h-4 w-4" /> Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-slate-300 hover:text-white transition-colors flex items-center gap-2" data-testid="footer-terms"><ScrollText className="h-4 w-4" /> Terms of Service</Link></li>
              <li><Link to="/contact-us" className="text-slate-300 hover:text-white transition-colors flex items-center gap-2" data-testid="footer-contact"><Mail className="h-4 w-4" /> Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Follow</p>
            <div className="mt-4 flex gap-3">
              <a href="https://www.facebook.com/profile.php?id=61593165861197" target="_blank" rel="noopener noreferrer" aria-label="Follow ReachMeNow on Facebook" className="h-10 w-10 rounded-xl bg-white/5 hover:bg-brand-blue transition-colors flex items-center justify-center" data-testid="footer-facebook"><Facebook className="h-5 w-5" /></a>
              <a href="https://www.instagram.com/reachmenowcanada/" target="_blank" rel="noopener noreferrer" aria-label="Follow ReachMeNow on Instagram" className="h-10 w-10 rounded-xl bg-white/5 hover:bg-brand-orange transition-colors flex items-center justify-center" data-testid="footer-instagram"><Instagram className="h-5 w-5" /></a>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-slate-400">© 2026 ReachMeNow. All rights reserved.</p>
        <p className="text-sm text-slate-400">Privacy-first contact for everyone.</p>
      </div>
    </div>
  </footer>
);
